import { SupportedLanguage } from '@/enum'
import { DropdownOption } from '@/types'

export const MARITALSTATUS_OPTIONS: DropdownOption = {
  [SupportedLanguage.English]: ['Never Married', 'Currently Married', 'Awaiting Divorce', 'Divorced', 'Widowed', 'Separated', 'Annulled'],
  [SupportedLanguage.Hindi]: [
    'अविवाहित',
    'वर्तमान में विवाहित',
    'तलाक की प्रतीक्षा में',
    'तलाकशुदा',
    'विधवा/विधुर',
    'अलग हुए',
    'रद्द की गई शादी',
  ],
  [SupportedLanguage.Marathi]: [
    'अविवाहित',
    'सध्या विवाहित',
    'तलाकाची प्रतीक्षा',
    'घटस्फोटित',
    'विधवा/विधुर',
    'वेगळे झालेले',
    'रद्द केलेले लग्न',
  ],
  [SupportedLanguage.Gujarati]: [
    'ક્યારેય લગ્ન નથી કર્યા',
    'હાલમાં લગ્નિત',
    'છૂટાછેડાની રાહ જોઈ રહ્યા છે',
    'છૂટાછેડા થઈ ગયા',
    'વિધુર/વિધવા',
    'અલગ થઈ ગયા',
    'લગ્ન રદ કરી દીધા',
  ],
  [SupportedLanguage.Bengali]: [
    'কখনো বিয়ে হয়নি',
    'বর্তমানে বিবাহিত',
    'বিবাহ বিচ্ছেদের অপেক্ষায়',
    'বিচ্ছিন্ন',
    'বিধবা',
    'পৃথক',
    'বিবাহ বাতিল',
  ],
  [SupportedLanguage.Telugu]: ['పెళ్లి చేసుకోలేదు', 'ప్రస్తుతం వివాహం', 'విడాకుల కోసం వేచి ఉంది', 'విడాకులు', 'వితంతువు', 'వేరు', 'రద్దు'],

  [SupportedLanguage.Kannada]: [
    'ಮದುವೆಯಾಗದ',
    'ಪ್ರಸ್ತುತ ವಿವಾಹಿತ',
    'ವಿಚ್ಛೇದನಕ್ಕಾಗಿ ಕಾಯುತ್ತಿದ್ದೇನೆ',
    'ವಿಚ್ಛೇದಿತ',
    'ವಿಧವೆ',
    'ಪ್ರತ್ಯೇಕಿಸಲ್ಪಟ್ಟ',
    'ರದ್ದುಗೊಂಡ',
  ],
  [SupportedLanguage.Tamil]: [
    'திருமணம் செய்யப்படவில்லை', // Never Married
    'திருமணமாகியுள்ளார்', // Currently Married
    'விவாகரத்திற்காக காத்திருக்கிறார்', // Awaiting Divorce
    'விவாகரத்து பெற்றவர்', // Divorced
    'மணமுடிக்கப்பட்டவர்', // Widowed
    'பிரிந்தவர்', // Separated
    'ரத்து செய்யப்பட்டது', // Annulled
  ],

  [SupportedLanguage.Odia]: [
    'କଦାପି ବିବାହିତ', // Never Married
    'ବର୍ତ୍ତମାନ ବିବାହିତ', // Currently Married
    'ବିବାହ ବିଚ୍ଛେଦ ପାଇଁ ଅପେକ୍ଷାରତ', // Awaiting Divorce
    'ବିବାହ ବିଚ୍ଛିନ୍ନ', // Divorced
    'ବିଧବା/ବିଧୁର', // Widowed
    'ପୃଥକ ହୋଇଛନ୍ତି', // Separated
    'ବିବାହ ବାତିଲ୍', // Annulled
  ],
  [SupportedLanguage.Malayalam]: [
    "ഒരിക്കലും വിവാഹിതരായിട്ടില്ല",
    "വിവാഹിതരാണ്",
    "വിവാഹ മോചനം കാത്തിരിക്കുന്നു",
    "വിവാഹ മോചിതർ",
    "വിധവ / വിധവൻ",
    "വേർപിരിഞ്ഞു",
    "വിവാഹം റദ്ദാക്കി"
  ],
}
